import { useQuery } from "@apollo/client";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  Box,
  Grid,
  LinearProgress,
  Link,
  Paper,
  Typography,
} from "@mui/material";
import { DateTime } from "luxon";
import { Link as RouterLink } from "react-router-dom";
import { gql } from "../../../../__generated__";
import styles from "./index.module.scss";

export default function LatestNews() {
  const { data, loading } = useQuery(GET_LATEST_NEWS);
  const latestNews = data?.news.records ?? [];

  if (!loading && latestNews.length === 0) return null;

  return (
    <Paper
      component="section"
      aria-label="Latest news"
      elevation={0}
      className={styles.container}
    >
      {loading && <LinearProgress color="error" />}
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {latestNews.map((news) => (
          <Grid item xs={12} md={4} key={news.id}>
            <Box
              component={RouterLink}
              to={`/news/${news.id}`}
              className={styles.article}
            >
              <Typography className={styles.date}>
                {DateTime.fromISO(news.date).toFormat("LLLL d, yyyy")}
              </Typography>
              <Typography component="h3" className={styles.title}>
                {news.translation?.title ?? ""}
              </Typography>
              <Typography className={styles.description}>
                {getExcerpt(news.translation?.content ?? "")}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box className={styles.actions}>
        <Link
          component={RouterLink}
          to="/news"
          underline="none"
          className={styles.link}
        >
          View all news
          <ChevronRightIcon className={styles.linkIcon} />
        </Link>
      </Box>
    </Paper>
  );
}

function getExcerpt(content: string) {
  return content.length > 140 ? `${content.slice(0, 137)}...` : content;
}

const GET_LATEST_NEWS = gql(`
  query GetLatestNews {
    news(input: { offset: 0, limit: 3 }) {
      records {
        id
        date
        translation(lang: en) {
          title
          content
        }
      }
    }
  }
`);
